import { Star } from "lucide-react";

export const CATEGORIES = [
  { value: "groceries", label: "Groceries" },
  { value: "delivery", label: "Pickup & Delivery" },
  { value: "petcare", label: "Pet Care" },
  { value: "carwash", label: "Car Wash" },
  { value: "yardwork", label: "Yard Work" },
  { value: "moving", label: "Moving & Lifting" },
  { value: "other", label: "Other" },
];

export const STATUS_STYLES = {
  open: "bg-[#E7F6F0] text-[#2F8F6E]",
  accepted: "bg-[#E6F1FA] text-[#2C6FA0]",
  in_progress: "bg-[#FFF1E9] text-[#C4531F]",
  completed: "bg-[#EEF0F2] text-[#4A5361]",
  cancelled: "bg-[#FBE9E9] text-[#B23B3B]",
};

export const STATUS_LABEL = {
  open: "Open",
  accepted: "Accepted",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};

export function StarRating({ value = 0, size = 16, className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "fill-[#FFB020] text-[#FFB020]" : "text-gray-300"}
        />
      ))}
    </div>
  );
}
